/* ==========================================================================
   Il était une fois nous : site tunnel (layout/iuf.liquid)
   - en-tête (menu mobile), galerie, avant/après, barre d'achat mobile
   - le questionnaire en étapes : prix en direct, photos, sauvegarde
     (« Reprendre là où j'en étais »), récapitulatif puis paiement
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const money = (cents) => {
    const e = Math.floor(cents / 100);
    const c = cents % 100;
    return (c ? e + ',' + String(c).padStart(2, '0') : String(e)) + ' €';
  };

  /* ---------- En-tête ---------- */
  function initHeader() {
    const header = $('[data-header]');
    const burger = $('[data-burger]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (burger) {
      burger.addEventListener('click', () => {
        const open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', String(open));
      });
      $$('.t-nav a', header).forEach((a) =>
        a.addEventListener('click', () => {
          header.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
        })
      );
    }
  }

  /* ---------- Galerie du produit ---------- */
  function initGallery() {
    const g = $('[data-gallery]');
    if (!g) return;
    const video = $('[data-gallery-video]', g);
    const img = $('[data-gallery-img]', g);
    // Lecture automatique, sans son : relancée dès que la vidéo est visible
    const tryPlay = () => {
      if (!video.hidden) video.play().catch(() => {});
    };
    video.muted = true;
    tryPlay();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => (e.isIntersecting ? tryPlay() : video.pause())).observe(video);
    }
    document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && tryPlay());
    $$('[data-thumb]', g).forEach((btn) =>
      btn.addEventListener('click', () => {
        $$('[data-thumb]', g).forEach((b) => b.classList.toggle('is-active', b === btn));
        if (btn.dataset.thumb === 'video') {
          img.hidden = true;
          video.hidden = false;
          video.play().catch(() => {});
        } else {
          video.pause();
          video.hidden = true;
          img.src = btn.dataset.thumb;
          img.hidden = false;
        }
      })
    );
  }

  /* ---------- Exemples : la vidéo ne se charge qu'au clic sur lecture ---------- */
  function initExamples() {
    $$('[data-example-src]').forEach((btn) =>
      btn.addEventListener('click', () => {
        const v = document.createElement('video');
        v.src = btn.dataset.exampleSrc;
        v.controls = true;
        v.playsInline = true;
        v.autoplay = true;
        v.setAttribute('aria-label', btn.getAttribute('aria-label') || '');
        btn.replaceWith(v);
        // Un seul film à la fois
        $$('.t-example video').forEach((o) => o !== v && o.pause());
        v.addEventListener('play', () => $$('.t-example video').forEach((o) => o !== v && o.pause()));
        v.play().catch(() => {});
      })
    );
  }

  /* ---------- Avant / après ---------- */
  function initBeforeAfter() {
    $$('[data-ba]').forEach((ba) => {
      const range = $('[data-ba-range]', ba);
      range.addEventListener('input', () => ba.style.setProperty('--pos', range.value + '%'));
    });
  }

  /* ---------- Barre d'achat mobile ---------- */
  function initMobileBar() {
    const bar = $('[data-mobile-bar]');
    const target = $('.t-tunnel__buy, [data-bar-target]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0)).observe(target);
  }

  /* ---------- Photos : stockées dans le navigateur pour la reprise ---------- */
  const photoDB = {
    db: null,
    open() {
      if (this.db) return Promise.resolve(this.db);
      return new Promise((resolve, reject) => {
        try {
          const req = indexedDB.open('iuf-tunnel', 1);
          req.onupgradeneeded = () => req.result.createObjectStore('photos');
          req.onsuccess = () => resolve((this.db = req.result));
          req.onerror = () => reject(req.error);
        } catch (e) {
          reject(e);
        }
      });
    },
    async run(mode, fn) {
      const db = await this.open();
      return new Promise((resolve, reject) => {
        const tx = db.transaction('photos', mode);
        const r = fn(tx.objectStore('photos'));
        tx.oncomplete = () => resolve(r && r.result);
        tx.onerror = () => reject(tx.error);
      });
    },
    put(key, blob) { return this.run('readwrite', (s) => s.put(blob, key)).catch(() => {}); },
    get(key) { return this.run('readonly', (s) => s.get(key)).catch(() => null); },
    del(key) { return this.run('readwrite', (s) => s.delete(key)).catch(() => {}); },
    clear() { return this.run('readwrite', (s) => s.clear()).catch(() => {}); },
  };

  /* Réduit la photo (1600 px max) pour un envoi rapide. */
  function shrinkPhoto(file) {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const im = new Image();
      im.onload = () => {
        const max = 1600;
        const k = Math.min(1, max / Math.max(im.width, im.height));
        const c = document.createElement('canvas');
        c.width = Math.round(im.width * k);
        c.height = Math.round(im.height * k);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob((b) => resolve(b || file), 'image/jpeg', 0.88);
      };
      im.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      im.src = url;
    });
  }

  /* ---------- Le questionnaire ---------- */
  const RECIPIENTS = ['Ma chérie', 'Mon chéri', 'Ma femme', 'Mon mari', 'Ma fiancée', 'Mon fiancé', 'Nous deux', 'Ma famille', 'Un(e) ami(e)', 'Autre'];
  const OCCASIONS = [
    'Anniversaire de couple', 'Juste pour dire je t’aime', 'Anniversaire', 'Saint-Valentin', 'Mariage',
    'Demande en mariage', 'Annonce de grossesse', 'Annonce du sexe du bébé', 'Noël', 'Autre',
  ];
  const MUSIC = ['Romantique', 'Joyeuse', 'Émouvante', 'Surprenez-nous'];
  const MOMENT_HINTS = [
    'Notre rencontre : où, comment ?',
    'Notre premier voyage, un lieu à nous…',
    'Un moment qu’on n’oubliera jamais',
    'Aujourd’hui : notre vie ensemble',
    'Un autre moment…',
  ];
  const EXAMPLE =
    '1. On s’est rencontrés au travail, nos bureaux étaient voisins.\n2. Notre premier voyage à Rome, une glace à la main.\n3. Notre mariage sous les guirlandes lumineuses.\n4. L’arrivée de Gabi, notre petit garçon.';
  const STEPS = ['pour', 'occasion', 'duree', 'moments', 'details', 'cartons', 'persos', 'voix', 'pourboire', 'recap'];
  const OPENING_DEFAULT = 'Il était une fois…';
  const STORE_KEY = 'iuf-tunnel-v1';

  function initTunnel() {
    const root = $('[data-tunnel]');
    const cfgEl = $('[data-tunnel-config]');
    if (!root || !cfgEl) return;

    let CFG;
    try {
      CFG = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    const filmVariants = CFG.film.variants || [];
    const tips = CFG.tip || [];
    const INCLUDED = CFG.includedMoments || 4;
    const MAX_MOMENTS = CFG.maxMoments || 10;
    const MAX_EXTRA_PERSONS = 4;

    const host = $('[data-step-host]', root);
    const btnNext = $('[data-next]', root);
    const btnPrev = $('[data-prev]', root);
    const errorEl = $('[data-error]', root);
    const resumeEl = $('[data-resume]', root);
    const progressEl = $('[data-progress]', root);
    const navEl = $('.t-nav-steps', root);

    const fresh = () => ({
      step: 0,
      recipient: '', recipientOther: '',
      occasion: '', occasionOther: '',
      length: 0,
      moments: Array(INCLUDED).fill(''),
      fetish: '', tattoo: '', details: '',
      cardStyle: 'nuit', openingText: '', endMessage: '',
      persons: [{ name: '', photo: false }, { name: '', photo: false }],
      voice: '', music: '',
      tip: null,
      showExample: false,
    });

    let state = fresh();
    const previews = {}; // index -> URL d'aperçu

    /* Sauvegarde / reprise */
    const save = () => {
      try {
        state.v2 = true;
        localStorage.setItem(STORE_KEY, JSON.stringify(state));
      } catch (e) {}
    };
    const load = () => {
      try {
        const raw = localStorage.getItem(STORE_KEY);
        if (!raw) return null;
        const s = Object.assign(fresh(), JSON.parse(raw));
        // Questionnaire sauvegardé avant l'ajout de l'étape « cartons » : on garde la même étape
        if (!s.v2 && s.step >= STEPS.indexOf('cartons')) s.step += 1;
        return s;
      } catch (e) {
        return null;
      }
    };
    async function loadPreviews() {
      for (let i = 0; i < state.persons.length; i++) {
        if (!state.persons[i].photo) continue;
        const blob = await photoDB.get('p' + i);
        if (blob) previews[i] = URL.createObjectURL(blob);
        else state.persons[i].photo = false;
      }
    }

    /* Prix */
    const extraMoments = () => Math.max(0, state.moments.length - INCLUDED);
    const extraPersons = () => Math.max(0, state.persons.length - 2);
    const filmPrice = () => (filmVariants[state.length] ? filmVariants[state.length].price : 0);
    const tipVariant = () => tips.find((t) => t.id === state.tip) || null;
    function lines() {
      const l = [];
      const v = filmVariants[state.length];
      l.push({ key: 'film', label: 'Film ' + (v ? v.title : ''), price: filmPrice() });
      if (extraMoments() && CFG.moment) l.push({ key: 'moments', label: extraMoments() + (extraMoments() > 1 ? ' moments en plus' : ' moment en plus'), price: extraMoments() * CFG.moment.price, remove: true });
      if (extraPersons() && CFG.person) l.push({ key: 'persons', label: extraPersons() + (extraPersons() > 1 ? ' personnes ou animaux en plus' : ' personne ou animal en plus'), price: extraPersons() * CFG.person.price, remove: true });
      if (state.voice === 'mine' && CFG.voice) l.push({ key: 'voice', label: 'Votre voix', price: CFG.voice.price, remove: true });
      if (tipVariant()) l.push({ key: 'tip', label: 'Pourboire pour l’artiste 🇫🇷', price: tipVariant().price, remove: true });
      return l;
    }
    const total = () => lines().reduce((s, x) => s + x.price, 0);

    const deliveryDate = () => {
      const d = new Date(Date.now() + 48 * 3600 * 1000);
      return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    };
    const recipientLabel = () => (state.recipient === 'Autre' ? state.recipientOther : state.recipient);
    const occasionLabel = () => (state.occasion === 'Autre' ? state.occasionOther : state.occasion);

    /* Rendu des étapes */
    const chips = (list, current, action) =>
      '<div class="t-chips">' +
      list.map((x) => `<button type="button" class="t-chip${x === current ? ' is-on' : ''}" data-act="${action}" data-val="${esc(x)}">${esc(x)}</button>`).join('') +
      '</div>';
    const title = (h, sub) => `<h2 class="t-step__title">${h}</h2>` + (sub ? `<p class="t-step__sub">${sub}</p>` : '');

    const views = {
      pour: () =>
        title('Pour qui est <em>ce film</em> ?', 'Choisissez une réponse.') +
        chips(RECIPIENTS, state.recipient, 'recipient') +
        (state.recipient === 'Autre' ? `<input class="t-input" data-field="recipientOther" value="${esc(state.recipientOther)}" placeholder="Pour qui ?" maxlength="60">` : ''),

      occasion: () =>
        title('Quelle est <em>l’occasion</em> ?') +
        chips(OCCASIONS, state.occasion, 'occasion') +
        (state.occasion === 'Autre' ? `<input class="t-input" data-field="occasionOther" value="${esc(state.occasionOther)}" placeholder="Quelle occasion ?" maxlength="60">` : ''),

      duree: () => {
        const base = filmVariants[0] ? filmVariants[0].price : 0;
        const subs = ['Idéal pour une surprise', 'Plus de temps pour chaque moment', 'Toute votre histoire'];
        return (
          title('Quelle <em>durée</em> pour votre film ?', INCLUDED + ' moments inclus dans tous les films.') +
          '<div class="t-options">' +
          filmVariants
            .map(
              (v, i) => `<button type="button" class="t-option${state.length === i ? ' is-on' : ''}" data-act="length" data-val="${i}">
                <span class="t-option__main"><strong>${esc(v.title)}</strong><span>${subs[i] || ''}</span></span>
                <span class="t-option__price">${i === 0 ? money(v.price) : '+' + money(v.price - base)}</span>
                ${i === 1 ? '<span class="t-option__badge">Le plus choisi</span>' : ''}
              </button>`
            )
            .join('') +
          '</div>'
        );
      },

      moments: () => {
        const rows = state.moments
          .map((m, i) => {
            const extra = i >= INCLUDED;
            return `<div class="t-moment">
              <label class="t-moment__n" for="t-m-${i}">${i + 1}</label>
              <textarea class="t-input t-input--grow" id="t-m-${i}" data-moment="${i}" rows="1" placeholder="${esc(MOMENT_HINTS[Math.min(i, MOMENT_HINTS.length - 1)])}" maxlength="400">${esc(m)}</textarea>
              ${extra ? `<button type="button" class="t-x" data-act="del-moment" data-val="${i}" aria-label="Retirer ce moment">×</button>` : ''}
            </div>`;
          })
          .join('');
        const canAdd = state.moments.length < MAX_MOMENTS && CFG.moment;
        return (
          title('Racontez-nous <em>vos moments</em>', 'Une phrase par moment suffit. Chaque moment devient une scène.') +
          `<div class="t-moments">${rows}</div>` +
          (canAdd ? `<button type="button" class="t-add" data-act="add-moment">+ Ajouter un moment <span>+${money(CFG.moment.price)}</span></button>` : '') +
          `<button type="button" class="t-link t-link--small" data-act="example">${state.showExample ? 'Masquer l’exemple' : 'Voir un exemple'}</button>` +
          (state.showExample ? `<p class="t-example-box">${esc(EXAMPLE).replace(/\n/g, '<br>')}</p>` : '')
        );
      },

      details: () =>
        title('Des petits détails <em>à ne pas oublier</em> ?', 'Facultatif. Ce sont eux qui rendent le film unique.') +
        `<label class="t-field">Un objet fétiche <small>(une peluche, un bijou, une voiture…)</small>
          <input class="t-input" data-field="fetish" value="${esc(state.fetish)}" maxlength="120"></label>
         <label class="t-field">Un tatouage <small>(où et lequel)</small>
          <input class="t-input" data-field="tattoo" value="${esc(state.tattoo)}" maxlength="120">
          <span class="t-hint">Pas d’inquiétude : si vous avez un tatouage, il apparaîtra dans le film.</span></label>
         <label class="t-field">Autre chose ? <small>(animal, tenue, lieu…)</small>
          <textarea class="t-input t-input--grow" data-field="details" rows="2" maxlength="600">${esc(state.details)}</textarea></label>`,

      cartons: () => {
        const opening = state.openingText.trim() || OPENING_DEFAULT;
        const ending = state.endMessage.trim() || 'Votre petit mot de la fin';
        const style = (val, name) =>
          `<button type="button" class="t-card-style t-card-style--${val}${state.cardStyle === val ? ' is-on' : ''}" data-act="card-style" data-val="${val}">
            <span class="t-card-style__screen">${esc(opening)}</span>
            <span class="t-card-style__name">${name}</span>
          </button>`;
        return (
          title('Le début et la fin <em>de votre film</em>', 'Facultatif. Votre film s’ouvre et se termine sur un carton avec votre texte.') +
          '<p class="t-step__label">La couleur des cartons</p>' +
          `<div class="t-card-styles">${style('nuit', 'Fond noir')}${style('ivoire', 'Fond blanc')}</div>` +
          `<label class="t-field">Le texte du début <small>(laissez vide pour « ${OPENING_DEFAULT} »)</small>
            <input class="t-input" data-field="openingText" data-live="cards" value="${esc(state.openingText)}" maxlength="80" placeholder="${esc(OPENING_DEFAULT)}"></label>
           <label class="t-field">Le petit mot de la fin
            <input class="t-input" data-field="endMessage" data-live="cards" value="${esc(state.endMessage)}" maxlength="140" placeholder="Joyeux anniversaire mon amour…"></label>
           <div class="t-card-preview t-card-preview--${state.cardStyle}" aria-hidden="true">
             <span data-preview-open>${esc(opening)}</span><span class="t-card-preview__sep">…</span><span data-preview-end>${esc(ending)}</span>
           </div>`
        );
      },

      persos: () => {
        const cards = state.persons
          .map((p, i) => {
            const extra = i >= 2;
            const pv = previews[i];
            return `<div class="t-person">
              <label class="t-person__photo${pv ? ' has-photo' : ''}">
                ${pv ? `<img src="${pv}" alt="">` : '<span>+ Photo</span>'}
                <input type="file" accept="image/*" data-photo="${i}" class="t-sr">
              </label>
              <div class="t-person__body">
                <input class="t-input" data-person="${i}" value="${esc(p.name)}" placeholder="${extra ? 'Prénom (personne ou animal)' : 'Prénom de la personne ' + (i + 1)}" maxlength="40">
                ${pv ? '<span class="t-hint">✓ Photo ajoutée · touchez-la pour la changer</span>' : ''}
              </div>
              ${extra ? `<button type="button" class="t-x" data-act="del-person" data-val="${i}" aria-label="Retirer">×</button>` : ''}
            </div>`;
          })
          .join('');
        const canAdd = extraPersons() < MAX_EXTRA_PERSONS && CFG.person;
        return (
          title('Qui sont <em>les héros</em> ?', 'Une photo nette par personne, visage et cheveux bien visibles.') +
          `<div class="t-persons">${cards}</div>` +
          (canAdd ? `<button type="button" class="t-add" data-act="add-person">+ Ajouter une personne ou un animal <span>+${money(CFG.person.price)}</span></button>` : '') +
          '<p class="t-hint">2 personnes incluses. Vos photos servent uniquement à créer votre film.</p>'
        );
      },

      voix: () => {
        const opt = (val, name, sub, price) =>
          `<button type="button" class="t-option${state.voice === val ? ' is-on' : ''}" data-act="voice" data-val="${val}">
            <span class="t-option__main"><strong>${name}</strong><span>${sub}</span></span>
            <span class="t-option__price">${price}</span>
          </button>`;
        return (
          title('Qui raconte <em>votre histoire</em> ?') +
          '<div class="t-options">' +
          opt('female', 'Voix féminine', 'Douce et chaleureuse', 'Inclus') +
          opt('male', 'Voix masculine', 'Grave et posée', 'Inclus') +
          (CFG.voice ? opt('mine', 'Votre voix ❤️', 'On vous envoie votre texte, vous l’enregistrez sur votre téléphone.', '+' + money(CFG.voice.price)) : '') +
          '</div>' +
          '<p class="t-step__label">Et la musique ?</p>' +
          chips(MUSIC, state.music, 'music')
        );
      },

      pourboire: () =>
        title('Un petit pourboire <em>pour l’artiste</em> ? 🇫🇷', 'Chaque film est créé avec amour dans le sud de la France. Votre pourboire nous va droit au cœur, merci !') +
        '<div class="t-chips">' +
        `<button type="button" class="t-chip${state.tip === null ? ' is-on' : ''}" data-act="tip" data-val="">Non merci</button>` +
        tips.map((t) => `<button type="button" class="t-chip${state.tip === t.id ? ' is-on' : ''}" data-act="tip" data-val="${t.id}">${money(t.price)}</button>`).join('') +
        '</div>',

      recap: () => {
        const rows = lines()
          .map(
            (l) => `<li><span>${esc(l.label)}</span><span class="t-recap__price">${money(l.price)}
              ${l.remove ? `<button type="button" class="t-x t-x--small" data-act="remove" data-val="${l.key}" aria-label="Retirer ${esc(l.label)}">×</button>` : ''}</span></li>`
          )
          .join('');
        const who = state.persons.map((p) => p.name).filter(Boolean).join(' & ');
        return (
          title('Presque fini ! <em>Votre film</em>') +
          `<dl class="t-summary">
            <div><dt>Pour</dt><dd>${esc(recipientLabel())}</dd></div>
            <div><dt>Occasion</dt><dd>${esc(occasionLabel())}</dd></div>
            <div><dt>Les héros</dt><dd>${esc(who)}</dd></div>
            <div><dt>Moments</dt><dd>${state.moments.filter((m) => m.trim()).length}</dd></div>
          </dl>
          <button type="button" class="t-link t-link--small" data-act="goto" data-val="0">Modifier mes réponses</button>
          <div class="t-lengths">${filmVariants
            .map((v, i) => `<button type="button" class="t-chip t-chip--sm${state.length === i ? ' is-on' : ''}" data-act="length" data-val="${i}">${esc(v.title)}</button>`)
            .join('')}</div>
          <ul class="t-recap">${rows}</ul>
          <p class="t-recap__total"><span>Total</span><strong>${money(total())}</strong></p>
          <ul class="t-checks">
            <li>✓ Livré par email au plus tard ${esc(deliveryDate())}</li>
            <li>✓ Retouches illimitées pendant 7 jours</li>
            <li>🎁 Après votre film : -10 % sur votre prochaine commande</li>
          </ul>
          <p class="t-legal-line">Votre film est personnalisé et sa création commence dès votre commande : il n’est pas soumis au droit de rétractation (art. L221-28 du Code de la consommation). En passant au paiement, vous acceptez nos <a href="/policies/terms-of-service" target="_blank" rel="noopener">conditions générales de vente</a> et notre <a href="/policies/refund-policy" target="_blank" rel="noopener">politique de remboursement</a>.</p>`
        );
      },
    };

    function render(focus) {
      const name = STEPS[state.step];
      host.innerHTML = `<div class="t-step__in">${views[name]()}</div>`;
      const n = state.step + 1;
      $('[data-progress-label]', root).textContent = 'Étape ' + n + ' sur ' + STEPS.length;
      $('[data-progress-total]', root).textContent = money(total());
      $('[data-progress-bar]', root).style.width = Math.round((state.step / (STEPS.length - 1)) * 100) + '%';
      btnPrev.hidden = state.step === 0;
      btnNext.disabled = false;
      if (name === 'recap') {
        btnNext.textContent = 'Payer mon film · ' + money(total());
        prepareCart();
      } else if (name === 'details' || name === 'cartons' || name === 'pourboire') btnNext.textContent = 'Continuer →';
      else btnNext.textContent = 'Suivant →';
      $$('.t-input--grow', host).forEach(grow);
      const mt = $('[data-mobile-total]');
      if (mt) mt.textContent = money(total());
      hideError();
      if (focus) {
        const t = $('.t-step__title', host);
        if (t) {
          t.setAttribute('tabindex', '-1');
          t.focus({ preventScroll: true });
        }
        const top = root.getBoundingClientRect().top + window.scrollY - 90;
        if (Math.abs(window.scrollY - top) > 200) window.scrollTo({ top, behavior: 'smooth' });
      }
      save();
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function hideError() {
      errorEl.hidden = true;
    }

    function validate() {
      switch (STEPS[state.step]) {
        case 'pour':
          if (!recipientLabel().trim()) return 'Choisissez pour qui est le film.';
          break;
        case 'occasion':
          if (!occasionLabel().trim()) return 'Choisissez l’occasion.';
          break;
        case 'moments': {
          const filled = state.moments.filter((m) => m.trim().length >= 3).length;
          if (filled < 2) return 'Racontez au moins 2 moments (une phrase suffit).';
          break;
        }
        case 'persos':
          for (let i = 0; i < state.persons.length; i++) {
            if (!state.persons[i].name.trim()) return 'Ajoutez le prénom de chaque personne.';
            if (!state.persons[i].photo) return 'Ajoutez une photo pour ' + state.persons[i].name.trim() + '.';
          }
          break;
        case 'voix':
          if (!state.voice) return 'Choisissez la voix qui raconte votre histoire.';
          if (!state.music) return 'Choisissez l’ambiance musicale.';
          break;
      }
      return '';
    }

    function go(step) {
      state.step = Math.max(0, Math.min(STEPS.length - 1, step));
      render(true);
    }

    function next() {
      const err = validate();
      if (err) return showError(err);
      if (STEPS[state.step] === 'recap') return checkout();
      go(state.step + 1);
    }

    /* Interactions */
    host.addEventListener('click', (e) => {
      const b = e.target.closest('[data-act]');
      if (!b) return;
      const v = b.dataset.val;
      switch (b.dataset.act) {
        case 'recipient':
          state.recipient = v;
          render();
          if (v !== 'Autre') setTimeout(next, 220);
          break;
        case 'occasion':
          state.occasion = v;
          render();
          if (v !== 'Autre') setTimeout(next, 220);
          break;
        case 'length':
          state.length = Number(v);
          render();
          break;
        case 'add-moment':
          state.moments.push('');
          render();
          $(`[data-moment="${state.moments.length - 1}"]`, host).focus();
          break;
        case 'del-moment':
          state.moments.splice(Number(v), 1);
          render();
          break;
        case 'example':
          state.showExample = !state.showExample;
          render();
          break;
        case 'add-person':
          state.persons.push({ name: '', photo: false });
          render();
          break;
        case 'del-person':
          removePerson(Number(v));
          break;
        case 'voice':
          state.voice = v;
          render();
          break;
        case 'music':
          state.music = v;
          render();
          break;
        case 'tip':
          state.tip = v ? Number(v) : null;
          render();
          break;
        case 'remove':
          if (v === 'moments') state.moments = state.moments.slice(0, INCLUDED);
          if (v === 'persons') {
            (async () => {
              while (state.persons.length > 2) await removePerson(state.persons.length - 1, true);
              render();
            })();
            return;
          }
          if (v === 'voice') state.voice = 'female';
          if (v === 'tip') state.tip = null;
          render();
          break;
        case 'goto':
          go(Number(v));
          break;
        case 'card-style':
          state.cardStyle = v;
          render();
          break;
      }
    });

    /* Les zones de texte s'agrandissent au fil de l'écriture : on voit tout ce qu'on a écrit */
    function grow(t) {
      t.style.height = 'auto';
      t.style.height = t.scrollHeight + 2 + 'px';
    }

    host.addEventListener('input', (e) => {
      const t = e.target;
      if (t.classList.contains('t-input--grow')) grow(t);
      if (t.dataset.field) state[t.dataset.field] = t.value;
      else if (t.dataset.moment) state.moments[Number(t.dataset.moment)] = t.value;
      else if (t.dataset.person) state.persons[Number(t.dataset.person)].name = t.value;
      else return;
      if (t.dataset.live === 'cards') {
        const open = state.openingText.trim() || OPENING_DEFAULT;
        $$('.t-card-style__screen', host).forEach((s) => (s.textContent = open));
        $('[data-preview-open]', host).textContent = open;
        $('[data-preview-end]', host).textContent = state.endMessage.trim() || 'Votre petit mot de la fin';
      }
      save();
    });

    host.addEventListener('change', async (e) => {
      const t = e.target;
      if (!t.dataset.photo || !t.files || !t.files[0]) return;
      const i = Number(t.dataset.photo);
      const blob = await shrinkPhoto(t.files[0]);
      await photoDB.put('p' + i, blob);
      if (previews[i]) URL.revokeObjectURL(previews[i]);
      previews[i] = URL.createObjectURL(blob);
      state.persons[i].photo = true;
      render();
    });

    async function removePerson(i, silent) {
      // Décale les photos suivantes d'un cran
      for (let k = i; k < state.persons.length - 1; k++) {
        const nextBlob = await photoDB.get('p' + (k + 1));
        if (nextBlob) await photoDB.put('p' + k, nextBlob);
        else await photoDB.del('p' + k);
        previews[k] = previews[k + 1];
      }
      await photoDB.del('p' + (state.persons.length - 1));
      delete previews[state.persons.length - 1];
      state.persons.splice(i, 1);
      if (!silent) render();
    }

    btnNext.addEventListener('click', next);
    btnPrev.addEventListener('click', () => go(state.step - 1));
    host.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('input.t-input')) {
        e.preventDefault();
        next();
      }
    });

    /* Paiement : le panier est vidé dès l'arrivée au récapitulatif (gain de temps au clic),
       puis on ajoute le film (avec réponses et photos) et les options, et on part au paiement. */
    let cartReady = null;
    function prepareCart() {
      if (!cartReady) {
        cartReady = fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).catch(() => null);
      }
      return cartReady;
    }

    async function checkout() {
      btnNext.disabled = true;
      btnNext.textContent = 'Préparation du paiement…';
      try {
        await prepareCart();
        cartReady = null; // au prochain passage, on revide le panier

        const fd = new FormData();
        fd.append('id', filmVariants[state.length].id);
        fd.append('quantity', '1');
        const prop = (k, v) => v && String(v).trim() && fd.append(`properties[${k}]`, String(v).trim());
        // Au paiement, le client ne voit que « Pour », « Occasion » et « Les héros ».
        // Les clés commençant par « _ » sont masquées au client mais gardées dans la commande (admin).
        prop('Pour', recipientLabel());
        prop('Occasion', occasionLabel());
        prop('Les héros', state.persons.map((p) => p.name.trim()).filter(Boolean).join(' & '));
        state.moments.forEach((m, i) => prop('_Moment ' + (i + 1), m));
        prop('_Objet fétiche', state.fetish);
        prop('_Tatouage', state.tattoo);
        prop('_Autres détails', state.details);
        prop('_Fond des cartons', state.cardStyle === 'ivoire' ? 'Blanc' : 'Noir');
        prop('_Texte du début', state.openingText.trim() || OPENING_DEFAULT);
        prop('_Message de fin', state.endMessage);
        prop('_Voix off', { female: 'Voix féminine', male: 'Voix masculine', mine: 'Votre voix (texte envoyé après la commande)' }[state.voice]);
        prop('_Musique', state.music);
        // Trace des mentions affichées au-dessus du bouton de paiement (CGV, pas de rétractation)
        const now = new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' });
        prop('_CGV acceptées', 'En passant au paiement, le ' + now);
        prop('_Info rétractation', 'Mention « pas de droit de rétractation » affichée avant le paiement, le ' + now);
        for (let i = 0; i < state.persons.length; i++) {
          prop('_Personne ' + (i + 1), state.persons[i].name);
          const blob = await photoDB.get('p' + i);
          if (blob) fd.append(`properties[_Photo ${i + 1}]`, blob, 'photo-' + (i + 1) + '.jpg');
        }
        const r1 = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r1.ok) throw new Error('film');

        const items = [];
        if (extraMoments() && CFG.moment) items.push({ id: CFG.moment.id, quantity: extraMoments() });
        if (extraPersons() && CFG.person) items.push({ id: CFG.person.id, quantity: extraPersons() });
        if (state.voice === 'mine' && CFG.voice) items.push({ id: CFG.voice.id, quantity: 1 });
        if (tipVariant()) items.push({ id: tipVariant().id, quantity: 1 });
        if (items.length) {
          const r2 = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!r2.ok) throw new Error('options');
        }
        window.location.href = '/checkout';
      } catch (err) {
        btnNext.disabled = false;
        render();
        showError('Oups, un souci est survenu. Réessayez, ou écrivez-nous à contact@iletaitunefoisnous.fr.');
      }
    }

    /* Retour arrière depuis la page de paiement : le navigateur réaffiche la page telle
       qu'on l'a quittée (bouton grisé « Préparation… »). On la remet en état. */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      cartReady = null;
      btnNext.disabled = false;
      if (!host.hidden) render();
    });

    root.classList.add('is-ready');

    /* Démarrage : proposer la reprise si un questionnaire est en cours */
    const saved = load();
    const hasProgress = saved && (saved.step > 0 || saved.recipient);
    const showForm = (on) => {
      host.hidden = !on;
      progressEl.hidden = !on;
      navEl.hidden = !on;
      resumeEl.hidden = on;
    };
    if (hasProgress) {
      showForm(false);
      $('[data-resume-go]', root).addEventListener('click', async () => {
        state = saved;
        await loadPreviews();
        showForm(true);
        render(true);
      });
      $('[data-resume-reset]', root).addEventListener('click', async () => {
        await photoDB.clear();
        state = fresh();
        showForm(true);
        render(true);
      });
    } else {
      render();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initGallery();
    initExamples();
    initBeforeAfter();
    initMobileBar();
    initTunnel();
  });
})();
